import { useState, useEffect, useMemo, useCallback } from "react";
import Layout from "./Layout.js";
import {
  feedback_dashboard,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import { handleError } from "../CommonJquery/CommonJquery.js";
import Loader from "./Loader.js";

export default function PointsInsights() {
  const [sosAlerts, setSosAlerts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch data
  useEffect(() => {
    const master_data_get = async () => {
      setIsLoading(true);
      try {
        const fd = new FormData();
        const Response = await server_post_data(feedback_dashboard, fd);
        if (Response?.data?.error) {
          handleError(Response.data.message || "Failed to load data");
          setSosAlerts([]);
        } else {
          const arr = Array.isArray(Response?.data?.data)
            ? Response.data.data
            : [];
          setSosAlerts(arr);
          console.log("SOS data:", arr);
        }
      } catch (err) {
        console.error(err);
        handleError("Something went wrong while fetching data.");
        setSosAlerts([]);
      } finally {
        setIsLoading(false);
      }
    };
    master_data_get();
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      <Layout>
        <div className="page">
          <h2 className="page-title">Point&apos;s Insight</h2>

          {/* TABLE (kept simple, null-guards) */}
          <div className="content-grid">
            <div className="table-container">
              <table className="table">
                <thead>
                  <tr className="table-header">
                    <th className="th">Sr.No.</th>
                    <th className="th">Point</th>
                    <th className="th">Location</th>
                    <th className="th">Major Issues</th>
                    <th className="th">Feedbacks</th>
                    <th className="th">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {(sosAlerts || []).length > 0 ? (
                    sosAlerts.map((alert, index) => {
                      const lat = Number(
                        alert?.lat ?? alert?.loc_lat ?? alert?.latitude
                      );
                      const lng = Number(
                        alert?.lng ??
                          alert?.long ??
                          alert?.loc_lng ??
                          alert?.longitude
                      );
                      const issues = Array.isArray(alert?.top_issues)
                        ? alert.top_issues
                        : [];
                      return (
                        <tr
                          key={`${lat}-${lng}-${index}`}
                          className="table-row"
                        >
                          <td className="td">{index + 1}</td>
                          <td
                            className="td"
                            style={{ color: "#000", fontWeight: 600 }}
                          >
                            {alert?.location || "—"}
                          </td>
                          <td className="td">
                            {Number.isFinite(lat) && Number.isFinite(lng) ? (
                              <a
                                href={`https://www.google.com/maps?q=${lat},${lng}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline"
                              >
                                {lat}, {lng}
                              </a>
                            ) : (
                              "—"
                            )}
                          </td>
                          <td className="td">
                            {issues[0]?.keyword || "-"},{" "}
                            {issues[1]?.keyword || "-"},{" "}
                            {issues[2]?.keyword || "-"}
                          </td>
                          <td className="td">
                            <div className="action-buttons">
                              <span
                                style={{
                                  color: "oklch(69.218% 0.20993 146.278)",
                                  fontWeight: 600,
                                }}
                              >
                                Positive: {alert?.positive ?? 0},
                              </span>
                              <span
                                style={{
                                  color: "oklch(0.769 0.188 70.08)",
                                  fontWeight: 600,
                                }}
                              >
                                {" "}
                                Neutral: {alert?.neutral ?? 0},
                              </span>
                              <span
                                style={{
                                  color: "oklch(0.577 0.245 27.325)",
                                  fontWeight: 600,
                                }}
                              >
                                {" "}
                                Negative: {alert?.negative ?? 0}
                              </span>
                            </div>
                          </td>
                          <td className="td">
                            <span
                              className={`type-badge ${
                                (alert?.action || "") !== "✅ No Major Issue"
                                  ? "missing"
                                  : "found"
                              }`}
                            >
                              {alert?.action || "—"}
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        className="td"
                        colSpan={6}
                        style={{ textAlign: "center" }}
                      >
                        No data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
